import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-end"
      }, {
        default: _withCtx(() => [
          (!_ctx.actions)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    block: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upsertCompany())),
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.company.id ? "Modifier" : "Créer"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                modelValue: _ctx.thirdPartyCompanyValid,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.thirdPartyCompanyValid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex pb-2 pr-2",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.name) = $event)),
                            type: "text",
                            label: _ctx.$t('user.companyName'),
                            rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                            required: "",
                            outlined: "",
                            readonly: _ctx.readonly,
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "label", "rules", "readonly"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "d-flex pb-2 pr-2",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.shortName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.shortName) = $event)),
                            type: "text",
                            label: _ctx.$t('settings.commercialName'),
                            outlined: "",
                            readonly: _ctx.readonly,
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "label", "readonly"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "d-flex pb-2 pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.siret,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.siret) = $event)),
                            outlined: "",
                            label: "SIRET",
                            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.company.siret = _ctx.truncateInput(_ctx.company.siret, 14))),
                            readonly: _ctx.readonly,
                            "data-cy": "editCompany-adress",
                            "hide-details": "auto",
                            onChange: _ctx.onSiretChange,
                            density: "compact"
                          }, null, 8, ["modelValue", "readonly", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "d-flex pb-2 pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.siren,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company.siren) = $event)),
                            outlined: "",
                            label: "SIREN",
                            readonly: "",
                            "data-cy": "editCompany-adress",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "d-flex pb-2 pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.vatNumber,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company.vatNumber) = $event)),
                            outlined: "",
                            label: "Num TVA",
                            readonly: _ctx.readonly,
                            "data-cy": "editCompany-adress",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex pb-2 pr-2",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.address,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company.address) = $event)),
                            type: "text",
                            label: _ctx.$t('settings.address') + ' *',
                            rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                            required: "",
                            outlined: "",
                            readonly: _ctx.readonly,
                            "data-cy": "editCompany-adress",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "label", "rules", "readonly"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex pb-2 pr-2",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.postalCode,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company.postalCode) = $event)),
                            type: "text",
                            label: _ctx.$t('settings.postalCode') + ' *',
                            rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                            required: "",
                            outlined: "",
                            readonly: _ctx.readonly,
                            "data-cy": "editCompany-postalCode",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "label", "rules", "readonly"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "d-flex pb-2 pr-2",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.company.city,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.company.city) = $event)),
                            type: "text",
                            label: _ctx.$t('settings.city') + ' *',
                            rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                            required: "",
                            outlined: "",
                            readonly: _ctx.readonly,
                            "data-cy": "editCompany-city",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "label", "rules", "readonly"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pl-2",
                        cols: "8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.company.vatOption,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company.vatOption) = $event)),
                            color: "primary",
                            inline: ""
                          }, {
                            default: _withCtx(() => [
                              _cache[12] || (_cache[12] = _createTextVNode(" Régime de TVA : ")),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableVatOptions, (option) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                  key: option.value,
                                  class: "pl-2",
                                  label: option.text,
                                  value: option.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}